import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import t from "@ext/localization/locale/translate";
import { Root as VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Button } from "@ui-kit/Button";
import { Dialog, DialogContent, DialogTitle } from "@ui-kit/Dialog";
import { ContentDivider } from "@ui-kit/Divider";
import { useCallback, useState } from "react";
import FetchService from "../../../ui-logic/ApiServices/FetchService";
import { GesCloudSignIn } from "../../enterpriseCommon/components/signIn/GesCloudSignIn";
import { GesCloudSignInHeader } from "../../enterpriseCommon/components/signIn/GesCloudSignInHeader";

interface SignInGesCloudFormProps {
	allowContinueWithoutAccount: boolean;
	className?: string;
	gesCloudUrl?: string;
}

interface SignInGesCloudFormModalProps extends SignInGesCloudFormProps {
	onClose: () => void;
}

export const GesCloudSignInFormModal = (props: SignInGesCloudFormModalProps) => {
	const { allowContinueWithoutAccount, onClose, className, gesCloudUrl } = props;
	const [open, setOpen] = useState(true);

	const onOpenChangeHandler = useCallback(
		(open: boolean) => {
			setOpen(open);
			if (!open) onClose();
		},
		[onClose],
	);

	return (
		<Dialog onOpenChange={onOpenChangeHandler} open={open}>
			<DialogContent data-modal-root>
				<VisuallyHidden>
					<DialogTitle>{t("welcome.editor.title")}</DialogTitle>
				</VisuallyHidden>
				<div className="p-4">
					<SignInGesCloudForm
						allowContinueWithoutAccount={allowContinueWithoutAccount}
						className={className}
						gesCloudUrl={gesCloudUrl}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export const SignInGesCloudForm = ({
	allowContinueWithoutAccount,
	className,
	gesCloudUrl: gesCloudUrlOverride,
}: SignInGesCloudFormProps) => {
	const apiUrlCreator = ApiUrlCreatorService.value;

	const handleContinueWithoutAccount = useCallback(async () => {
		await FetchService.fetch(apiUrlCreator.getDisableCloudUrl());
		refreshPage();
	}, []);

	return (
		<GesCloudSignIn
			className={className}
			footer={
				allowContinueWithoutAccount && (
					<div className="flex flex-col gap-4">
						<ContentDivider>
							<div className="text-sm text-center font-normal text-muted whitespace-nowrap">
								{t("or")}
							</div>
						</ContentDivider>
						<Button onClick={handleContinueWithoutAccount} type="button" variant="text">
							{t("enterprise-cloud-guest.buttons.continueWithoutAccount")}
						</Button>
					</div>
				)
			}
			gesCloudUrl={gesCloudUrlOverride}
			header={<GesCloudSignInHeader />}
		/>
	);
};
